export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f3675c44efa5f76a914800ca548c7aaf1d6a9076e&name=fetchTypeahead!'